import React from 'react';
    import {Link} from 'react-router-dom';
    import {motion} from 'framer-motion';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';
    import {useBrandKit} from '../contexts/BrandKitContext';
    import BrandKitCard from '../components/BrandKitCard';
    
    const {FiUpload,FiRefreshCw,FiLock,FiImage,FiType,FiPalette,FiSettings,FiPlus,FiStar}=FiIcons;
    
    const ProcessDocumentCard=()=> (
     <Link to="/process" className="block">
     <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col items-center justify-center p-8 text-center hover:border-gray-300 transition-colors">
     <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
     <SafeIcon icon={FiUpload} className="w-8 h-8 text-blue-600" />
     </div>
     <h2 className="text-xl font-semibold text-gray-900 mb-2">Process New Document</h2>
     <p className="text-gray-600">Upload and rebrand a document with your professional brand</p>
     </div>
     </Link>
    );
    
    const ServerStatus=({kitsCount})=> {
      const {refreshBrandKits}=useBrandKit();
      return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-end justify-between">
            <div className="flex items-center space-x-2">
              <span className="w-2.5 h-2.5 bg-green-500 rounded-full"></span>
              <p className="text-sm text-gray-600">
                Connected to server • Last updated: {new Date().toLocaleTimeString()}
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-800 mb-1">{kitsCount} brand kits loaded</p>
              <button
                onClick={()=> refreshBrandKits()}
                className="inline-flex items-center space-x-1 text-sm text-blue-600 hover:text-blue-700 transition-colors"
              >
                <SafeIcon icon={FiRefreshCw} className="w-3 h-3" />
                <span>Refresh from Server</span>
              </button>
            </div>
          </div>
        </div>
      );
    };
    
    const EffectiveBrandKit=({kit})=> {
    if (!kit) {return (
     <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200 text-center">
     <h2 className="text-xl font-semibold text-gray-900 mb-2">No Active Brand Kit</h2>
     <p className="text-gray-600">Please select a brand kit to see its details here.</p>
     </div>
    );}
    const displayColors=kit?.colors ? {Primary: kit.colors.primary,Accent: kit.colors.accent,Background: kit.colors.background,Secondary: kit.colors.secondary,Highlight: kit.colors.highlight,} : {};
    const displayFonts=kit?.fonts ? {Titles: kit.fonts.title,Body: kit.fonts.body,Subtitle: kit.fonts.subtitle,Heading: kit.fonts.heading,Highlight: kit.fonts.highlight,} : {};
    return (
     <div>
     <h2 className="text-xl font-semibold text-gray-900 mb-4">Effective Brand Kit (Live from Server)</h2>
     <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
     <div className="flex items-start justify-between mb-6">
     <div>
     <h3 className="text-lg font-semibold text-gray-900 flex items-center">
    {kit.name}
     <SafeIcon icon={FiLock} className="w-4 h-4 text-yellow-500 ml-2" />
     <div className="ml-2 flex items-center space-x-1 text-xs font-medium text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full">
     <SafeIcon icon={FiStar} className="w-3 h-3" />
     <span>Active</span>
     </div>
     </h3>
     <p className="text-sm text-gray-500">
    Professional brand • Last modified: {new Date(kit.updated_at).toLocaleString()}
     </p>
     </div>
     <Link to={`/brand-kit?edit=${kit.id}`} className="flex items-center space-x-2 px-3 py-1.5 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
     <SafeIcon icon={FiSettings} className="w-4 h-4" />
     <span>Manage Brand Kit</span>
     </Link>
     </div>
     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
     <div className="space-y-2">
     <h4 className="font-semibold text-sm text-gray-800 flex items-center"><SafeIcon icon={FiPalette} className="w-4 h-4 mr-2 text-gray-500" /> Locked Brand Colors</h4>
     <div className="space-y-1">
    {Object.entries(displayColors).filter(([,color])=> color).map(([name,color])=> (
     <div key={name} className="flex items-center space-x-2">
     <div className="w-4 h-4 rounded-sm border border-gray-200" style={{backgroundColor: color}} />
     <span className="text-xs text-gray-700 capitalize">{name}:</span>
     <span className="text-xs text-gray-500 font-mono">{color}</span>
     </div>
    ))}
     </div>
     </div>
     <div className="space-y-2">
     <h4 className="font-semibold text-sm text-gray-800 flex items-center"><SafeIcon icon={FiType} className="w-4 h-4 mr-2 text-gray-500" /> Locked Typography</h4>
     <div className="space-y-1">
    {Object.entries(displayFonts).filter(([,font])=> font).map(([name,font])=> (
     <p key={name} className="text-xs">
     <span className="text-gray-700 capitalize">{name}: </span>
     <span className="text-gray-500">{font}</span>
     </p>
    ))}
     </div>
     </div>
     <div className="space-y-2">
     <h4 className="font-semibold text-sm text-gray-800 flex items-center"><SafeIcon icon={FiImage} className="w-4 h-4 mr-2 text-gray-500" /> Logo Assets</h4>
     <p className="text-xs text-gray-500">{kit.logos?.length || 0} logos</p>
     <div className="p-2 bg-gray-100 border border-gray-200 rounded-md text-center">
     <p className="text-xs text-gray-500">No logos uploaded</p>
     </div>
     </div>
     <div className="space-y-2">
     <h4 className="font-semibold text-sm text-gray-800 flex items-center"><SafeIcon icon={FiImage} className="w-4 h-4 mr-2 text-gray-500" /> Watermark Assets</h4>
     <p className="text-xs text-gray-500">{kit.watermarks?.length || 0} watermarks</p>
     <div className="p-2 bg-gray-100 border border-gray-200 rounded-md text-center">
     <p className="text-xs text-gray-500">No watermarks uploaded</p>
     </div>
     </div>
     </div>
     </div>
     </div>
    );};
    
    const AllBrandKits=({kits})=> {
    const {selectBrandKit,selectedKit}=useBrandKit();
    return (
     <div>
     <div className="flex items-center justify-between mb-4">
     <h2 className="text-xl font-semibold text-gray-900">All Brand Kits ({kits.length})</h2>
     <Link to="/brand-kit" className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
     <SafeIcon icon={FiPlus} className="w-4 h-4" />
     <span>Create New Brand Kit</span>
     </Link>
     </div>
     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {kits.map(kit=> (
     <BrandKitCard key={kit.id} kit={kit} isActive={selectedKit?.id===kit.id} onSetActive={()=> selectBrandKit(kit)} />
    ))}
     </div>
     </div>
    );};
    
    const HowToUse=()=> {
    const steps=[ {num: 1,title: 'Manage Brand Kit',description: 'Add your logos and watermarks to personalize your brand kit.'},{num: 2,title: 'Set Active Kit',description: 'Choose your active brand kit for document processing.'},{num: 3,title: 'Upload Document',description: 'Upload any PDF,Word doc,or PowerPoint presentation.'},{num: 4,title: 'Download Branded',description: 'Get your professionally branded document ready to share.'},];
    return (
     <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
     <h2 className="text-xl font-semibold text-gray-900 text-center mb-6">How to Use Rebrand Studio</h2>
     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
    {steps.map(step=> (
     <div key={step.num} className="text-center">
     <div className="w-12 h-12 bg-gray-100 text-blue-600 font-bold text-xl rounded-full flex items-center justify-center mx-auto mb-4">{step.num}</div>
     <h3 className="font-semibold text-gray-900 mb-2">{step.title}</h3>
     <p className="text-sm text-gray-600">{step.description}</p>
     </div>
    ))}
     </div>
     </div>
    );};
    
    const Dashboard=()=> {
    const {brandKits,selectedKit,loading}=useBrandKit();
    if (loading) {return (
     <div className="flex items-center justify-center h-[calc(100vh-80px)]">
     <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600"></div>
     </div>
    );}
    return (
     <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pt-28">
     <motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6}} className="space-y-8" >
     <ProcessDocumentCard />
     <ServerStatus kitsCount={brandKits.length} />
     <EffectiveBrandKit kit={selectedKit} />
     <AllBrandKits kits={brandKits} />
     <HowToUse />
     </motion.div>
     </div>
    );};
    
    export default Dashboard;